import { observer } from 'mobx-react-lite'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import { RadioGroup, SimpleModal } from '../../../../ui-components'
import { useSearchStore } from '../../../../store/search/SearchStore'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import {
  create as createNiceModal,
  show as showNiceModal,
  useModal,
} from '@ebay/nice-modal-react'
import { formatVehicleDisplayWithOutEngine } from 'src/helpers/utils'
import { useSpecificConditionStore } from '../../../../store/specificConditions/SpecificConditionsStore'
import { PartsCatalogType } from '../../../../store/partsCatalog/PartsCatalog'
import { SpecificConditionsModal } from 'src/features/specificConditions/components/SpecificConditionsModal'

export const ProductEngineSelector = createNiceModal(
  observer((): ReactElement => {
    const {
      currentVehicle,
      engineOptionsForProducts,
      updateCurrentVehicle,
      searchBySaytCategories,
      cgts,
      setIsLoading,
    } = useSearchStore()
    const {
      fetchSpecificConditionQuestions,
      areAllQuestionsAnswered,
      processQuestions,
    } = useSpecificConditionStore()
    const navigate = useNavigate()
    const modal = useModal()

    const [selectedEngine, setSelectedEngine] = useState(undefined)

    useEffect(() => {
      if (selectedEngine !== undefined || engineOptionsForProducts?.length <= 0)
        return
      setSelectedEngine(engineOptionsForProducts[0])
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [engineOptionsForProducts])

    const onSelectedEngine = async (selectedEngine) => {
      setIsLoading(true)
      handleOnClose()
      const updatedVehicle = {
        ...currentVehicle,
        engine: selectedEngine,
      }
      await updateCurrentVehicle(updatedVehicle)

      const terminologies = cgts.reduce((acc, curr) => {
        acc.push({
          groupId: +curr?.group?.id,
          id: +curr?.terminology?.id,
          value: '',
        })
        return acc
      }, [])

      try {
        const questions = await fetchSpecificConditionQuestions(
          { ...updatedVehicle, initialized: undefined },
          terminologies,
          PartsCatalogType.PARTS_SEARCH
        )
        if (questions.length > 0 && !areAllQuestionsAnswered()) {
          setIsLoading(false)
          showNiceModal(SpecificConditionsModal, {
            proceed: () => {
              searchBySaytCategories(cgts, 0)
              navigate('/searchResults')
            },
          })
          return
        }
        processQuestions()
      } catch {
        // If specific conditions fail, proceed with search
      }

      searchBySaytCategories(cgts, 0)
      navigate('/searchResults')
    }

    const handleOnClose = useCallback(() => {
      modal.remove()
    }, [modal])

    return (
      <SimpleModal
        title="selectVehicleEngine"
        primaryActionText="next"
        secondaryActionText="cancel"
        onPrimaryAction={() => {
          onSelectedEngine(selectedEngine)
        }}
        onSecondaryAction={() => {
          handleOnClose()
        }}
        onCancel={() => {
          handleOnClose()
        }}
        show={modal.visible}
      >
        <Grid container className="py-4 mx-0">
          <Grid
            item
            xs={12}
            className="my-4 mt-0"
            style={{ fontWeight: 700, fontSize: '14px' }}
          >
            {formatVehicleDisplayWithOutEngine(currentVehicle)}
          </Grid>
          <Grid item>
            <RadioGroup
              id="selectEngineRadioGroup"
              name="chooseVehicleSystem"
              options={engineOptionsForProducts}
              onChange={(selected) => {
                setSelectedEngine(selected)
              }}
              initialValue={selectedEngine?.id}
            />
          </Grid>
        </Grid>
      </SimpleModal>
    )
  })
)
